export const Logo = ({ size = 40, withWordmark = true, className = "", variant = "light" }) => {
  const wordmarkBlue = variant === "dark" ? "#FFFFFF" : "#1E3A8A";
  const wordmarkGold = variant === "dark" ? "#F4C430" : "#C9A227";
  const subtle = variant === "dark" ? "#F4C430" : "#1E3A8A";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/branding/logo-emblem-512.png"
        alt="Africa Art Masters logo — golden fingerprint map of Africa"
        width={size}
        height={size}
        className="flex-shrink-0 object-cover"
        style={{ width: size, height: size }}
      />
      {withWordmark && (
        <div className="flex flex-col leading-none">
          <span className="font-serif-display text-[1.35rem] tracking-tight font-medium">
            <span style={{ color: wordmarkBlue }}>Africa</span>
            <span style={{ color: wordmarkGold }}>Art</span>
            <span style={{ color: wordmarkBlue }}>Masters</span>
          </span>
          <span className="text-[0.6rem] font-semibold uppercase tracking-[0.25em] mt-1.5" style={{ color: subtle }}>
            Original · Curated · Direct
          </span>
        </div>
      )}
    </div>
  );
};
